import {resolveBackground} from '#core/utils/color-utils.js';

import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';

import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import SCHEMA from './promotions.schema.yaml';
import PALETTE_SCHEMA from './promotions.palette-schema.yaml';

class PromotionsFeature extends AbstractVisualFeature {
    get name() {
        return 'Promotions';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        const {FONT} = PALETTE;

        return {
            BannerSkeletons: {
                bannerSkeletonContainer: {
                    style: {
                        // Keep the same aspect ratio as set for BannerPromotionsView.banner.image.style.aspectRatio
                        aspectRatio: this.config.aspectRatio,
                        _mobile_aspectRatio: this.config.mobileAspectRatio,
                    },
                },
                bannerSkeleton: generateSkeletonPart(PALETTE.SKELETON),
            },
            BannerPromotionsView: {
                banner: {
                    image: {
                        style: {
                            aspectRatio: this.config.aspectRatio,
                            _mobile_aspectRatio: this.config.mobileAspectRatio,
                            _mobile_objectFit: 'inherit',
                        },
                    },
                },
                style: {
                    container: {
                        ...resolveBackground(PALETTE.BANNER_CONTAINER_BG),
                    },
                },
                headerSkeleton: generateSkeletonPart(PALETTE.SKELETON),
                swiper: {
                    style: {
                        aspectRatio: this.config.aspectRatio,
                        _mobile_aspectRatio: this.config.mobileAspectRatio,
                    },
                    slide: {
                        style: {
                            flexBasis: '100%',
                        },
                    },
                },
            },
            BannerPromotion: {
                bannerMarket: {
                    eventName: {
                        margin: '10px 0 5px 0',
                        text: {
                            fontSize: FONT.SIZE_MEDIUM,
                            _mobile_fontSize: FONT.SIZE_XSMALL,
                            ...PALETTE.BANNER_MARKET_TEXT,
                            ...PALETTE.BANNER_MARKET_EVENT_NAME_TEXT,
                        },
                    },
                    sportLeague: {
                        padding: '4px 0 0 4px',
                        boxSizing: 'border-box',
                        textStyles: {
                            fontSize: FONT.SIZE_XXSMALL,
                            _mobile_fontSize: '10px',
                            ...PALETTE.BANNER_MARKET_TEXT,
                            ...PALETTE.BANNER_MARKET_SPORT_LEAGUE_TEXT,
                        },
                    },
                    startTime: {
                        top: 4,
                        right: 4,
                        textStyles: {
                            fontSize: FONT.SIZE_XXSMALL,
                            _mobile_fontSize: '10px',
                            ...PALETTE.BANNER_MARKET_TEXT,
                            ...PALETTE.BANNER_MARKET_START_TIME_TEXT,
                        },
                    },
                    participants: {
                        width: '70%',
                        _mobile_width: '95%',
                        minWidth: '300px',
                    },
                },
                marketOverlay: {
                    style: {
                        ...resolveBackground(PALETTE.BANNER_MARKET_CONTAINER_BG),
                        display: 'block',
                    },
                },
            },
        };
    }
}

new PromotionsFeature(allVisuals);
